import moment from 'moment'

const GUEST_STATUS_REJECTED = 2
const MINUTE_MS = 60000

export const isDeclined = (guest) => !guest.isCheckedIn && guest.status === GUEST_STATUS_REJECTED

export const isPendingCheckIn = (guest) => !guest.isCheckedIn && !isDeclined(guest)

export const getGuestLabel = (guest) => guest.name || guest.username || ''

export const getCheckInWindow = (detail, nowMs) => {
  const startMs = new Date(detail.startDatetime.replace('Z', '')).valueOf()
  const openMs = startMs - (detail.checkInBefore || 0) * MINUTE_MS
  const closeMs = startMs + (detail.checkInAfter || 0) * MINUTE_MS

  return {
    isOpen: nowMs >= openMs && nowMs <= closeMs,
    text: `${moment(openMs).format('HH:mm')} - ${moment(closeMs).format('HH:mm')}`
  }
}
